import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  participantsDetail: '',
};

export const participantSlice = createSlice({
  name: 'participant',
  initialState,
  reducers: {
    participant: (state, action) => {
      state.participantsDetail = action.payload
    },
  },
});

export const { participant } = participantSlice.actions;

export default participantSlice.reducer;
